<p-dialog
  header="Visualização de Documento"
  [(visible)]="visible"
  [style]="{
    width: '50rem',
  }"
  [draggable]="false"
  (onHide)="inputClose.emit(true)"
>
  <div class="container">
    <h1 class="name" *ngIf="!documentoData.nomePessoa">
      {{ documentoData.nomeDocumento }}
    </h1>
    <h1 class="name" *ngIf="documentoData.nomePessoa">
      {{ documentoData.nomeDocumento + " - " + documentoData.nomePessoa }}
    </h1>
    <img
      *ngIf="documentoData.base64"
      [src]="base64Prefix + documentoData.base64"
    />
    <h2 *ngIf="!documentoData.base64">Sem imagem do documento!</h2>
  </div>
</p-dialog>

<div *ngIf="visible" class="blur-overlay"></div>
